import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography } from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { list } from "../../../../controllers/V1/products/productController";
import Loading from "../../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";

const VendorListDeletePopUp = ({ popUpOpen, togglePopUp }) => {
  const handleCancel = () => togglePopUp();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleExport = async (e) => {
    e.preventDefault(); // Prevent the default form submission

    setError(null); // Reset the error state before each request
    try {
      setIsLoading(true);
      const formData = new FormData(e.target);

      const option = {
        isExport : true,
        condition: {
          ...(formData.get("name") && { name: { $regex: formData.get("name"), $options: "i" } } ),
          ...(formData.get("status") && { status: formData.get("status") } ),
        },
        select: {
          seq_id : true,
          name : true,
          description : true,
          status : true,
          createdAt : true,

        },
      };

      // Make the API call
      const res = await list(option);
      if (res.status === true) {
        await exportToExcel(res.result); // Export the results to Excel
        handleCancel(); // Reset the form or close modal
      } else {
        setError("No records found matching the criteria.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError("An error occurred while exporting the data.");
      console.error("Export Error:", error);
    }
  };

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Product-Orders");
      XLSX.writeFile(workbook, `Products ${new Date()}.xlsx`);
    } catch (error) {
      alert("Error generating Excel file: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography variant="h5" component="div" gutterBottom className="inventory_popup_title_heading">
            Export product variant 
          </Typography>
          <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>

        <Typography variant="body1" component="div" className="my_delete_popup_paragraph">
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form onSubmit={handleExport}>
                <div className="form-group row">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="code" className="all_lable_for_vendor_dashbaord">Name :</label>
                    <input type="text" name="name" id="name" placeholder="Search by Product's Name" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="status" className="all_lable_for_vendor_dashbaord">Status :</label>
                    <select name="status" id="status" className="form-control categories_select_tg_enter_product">
                      <option value='' selected>All</option>
                      <option value='A'>Active</option>
                      <option value='I' >Inactive</option>
                    </select>
                    {/* <input type="text" name="slug" id="slug" placeholder="slug" className="form-control categories_select_tg_enter_product" /> */}
                  </div>
  

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button type="button" className="btn btn-light categories_cancel_button" style={{ width: "25%" }} onClick={handleCancel}>Cancel</button>
                      <button type="submit" className="btn btn-danger" style={{ width: "25%" }} disabled={isLoading}>Download Excel</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
